import type { Guide, GuideRecordHint } from '../types';

/** S-21.10-04 — wniosek o wyjątek od bramki publikacji (scenariusz e2e 17, ścieżki TRD-03, MIX-03). */
const TRADE_ORDER: GuideRecordHint = {
  description: 'zlecenie w Trade, którego klient zakazuje podwykonawców albo dopuszcza ich warunkowo',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'TRADE' },
};

export const guide: Guide = {
  flagKey: 'publicationExceptionRequests',
  title: 'Wniosek o wyjątek od bramki publikacji',
  whatItDoes:
    'Gdy klient zakazuje podwykonawców albo trader nie może potwierdzić jego warunków, trader składa przy zleceniu wniosek o wyjątek z powodem. Wniosek trafia na listę „Wnioski o wyjątek” do osób z uprawnieniem „Akceptacja wyjątku od zakazu podwykonawcy”, które go zatwierdzają albo odrzucają z powodem — dopiero zatwierdzony przepuszcza publikację. Uprawnienie nadaje administrator imiennie na koncie, a listę reguł podwykonawców można wgrać z pliku.',
  audience: ['Trade', 'osoby z uprawnieniem do wyjątków', 'administrator'],
  presentationItems: ['S-21.10-04'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'exception-section',
      mockupTestId: 'trd-publikacja-bramka',
      title: 'Zakaz klienta przy publikacji',
      description:
        'Przy zleceniu klienta z zakazem przycisk giełdy jest nieaktywny, a pod nim powód i „Poproś o wyjątek”.',
      action: 'Otwórz zlecenie w Trade i przejdź do sekcji publikacji na giełdach.',
      recorder: { account: 'trade', demo: { kind: 'order', number: 'DEMO/2026/10/P01' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'exception-reason-input',
      mockupTestId: 'trd-zlecenie-wniosek-sales',
      title: 'Wniosek z powodem',
      description:
        'Wniosek wymaga powodu (co najmniej 10 znaków). Trafia do osób z uprawnieniem i do historii zlecenia; nic nie wychodzi na giełdę ani pocztą.',
      action: 'Kliknij „Poproś o wyjątek”, wpisz powód i „Złóż wniosek”.',
      recorder: {
        account: 'trade',
        demo: { kind: 'order', number: 'DEMO/2026/10/P01' },
        actions: [
          { kind: 'click', target: 'exception-request-button' },
          { kind: 'fill', target: 'exception-reason-input', value: 'Klient zgodził się mailem na podwykonawcę.' },
        ],
      },
    },
    {
      route: '/publication-exceptions',
      target: 'publication-exceptions',
      mockupTestId: 'sal-akceptacje-zgoda',
      title: 'Lista „Wnioski o wyjątek”',
      description:
        'Osoba z uprawnieniem widzi tu wnioski czekające na decyzję (licznik w menu i dzwonek) i zatwierdza albo odrzuca je z powodem. Własnych wniosków nie rozstrzyga.',
      action: 'Otwórz „Wnioski o wyjątek” w grupie „Giełdy” i kliknij „Zatwierdź” albo „Odrzuć”.',
      recorder: { account: 'sales' },
    },
    {
      route: '/users/:userId',
      record: { description: 'konto osoby, która ma zatwierdzać wyjątki', listPath: '/users' },
      target: 'permission-grants',
      title: 'Uprawnienie imienne',
      description:
        'Administrator nadaje „Akceptację wyjątku od zakazu podwykonawcy” imiennie na koncie użytkownika, z powodem. Do czasu imiennej listy od Marathonu mają je tylko administratorzy.',
      action: 'Na koncie użytkownika zaznacz uprawnienie, wpisz powód i zapisz.',
      recorder: { account: 'admin', demo: { kind: 'user', account: 'sales' } },
    },
    {
      route: '/contractors',
      target: 'rule-import-open',
      title: 'Reguły podwykonawców z pliku',
      description:
        'W kartotece kontrahentów administrator wgrywa listę reguł (numer klienta w TMS albo NIP i reguła) z pliku CSV albo Excel — najpierw podgląd zmian i raport nieznanych kontrahentów, potem zapis.',
      action: 'Kliknij „Wgraj listę reguł podwykonawców”, wybierz plik i sprawdź podgląd przed zapisem.',
      recorder: { account: 'admin' },
    },
  ],
};
